module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedMedium.61a4cfd.ttf";